import { createMuiTheme } from '@material-ui/core/styles';
import { white, black } from '@material-ui/core/colors';

export const muitheme = createMuiTheme({
  typography: {
    fontFamily: "Helvetica",
    fontSize: 23,
    fontWeightLight: 300,
    fontWeightRegula: 400,
    fontWeightMedium: 500,
    h4: {
      fontSize: 23,
      fontFamily: "\"Rock Salt\"",
      color: "#393c42",
    },
    h3: {
      fontFamily: "\"Rock Salt\"",
      color: "#393c42",
    },
    h2: {
      fontFamily: "\"Rock Salt\"",
      color: "#393c42",
    },
    h1: {
      fontFamily: "\"Rock Salt\"",
      color: "#393c42",
    },
  },
  ul: {
    paddingInlineStart: 0,
  },
  spacing: [10],
  palette: {
    primary: {
      main: '#434446 ',
    },
    secondary: {
      main: '#929395',
    },
    title: {
      color: 'white',
    },
    background: {
      main: "#cbd0d8"
    }
  },
  overrides: {
    MuiAppBar: {
      root: {
        background: 'linear-gradient(45deg, #434446 30%, #929395 90%)',
        borderRadius: 3,
        border: 0,
        color: black,
        height: 80,
        padding: '0 0px',
        position: 'absolute',
        width: '100%',
        zIndex: '1400',
      },
    },
    MuiButton: {
      root: {
        marginTop: "25px",
      }
    },
    MuiInputBase: {
      root: {
        marginTop: '10px',
        marginBotom: '10px'
      }
    },
    MuiDrawer: {
      paper: {
        docked: true,
        width: '15%',
        position: 'absolute',
        top: '80px'

      }
    },
    MUIDataTable: {
      paper: {
        boxShadow: "none"
      },
     
    },
    
  },
});

export default muitheme;



// WEBPACK FOOTER //
// ./src/theme/muiTheme.js